import React from 'react'
import { useEffect, useState, useRef } from 'react'
import { createPortal } from 'react-dom'
import styled, { css } from 'styled-components'
import { useModalStore } from './state'
import { ModalContainer } from './modal'
import Div100vh from 'react-div-100vh'
import { isMobileOnly } from 'react-device-detect'
import { createStore, createEvent } from 'effector'
import { useMatchMedia, useZIndexModal, VoidFnType } from '@rst/libs-ts'
import { nanoid } from 'nanoid'

type UseModalType = {
	def?: boolean
	notStyledModal?: boolean
	value?: boolean
	wrapperStyle?: any
	afterClose?: VoidFnType
}
export const useModal = (props: UseModalType = {}) => {
	const [id] = useState(nanoid())
	const { def = false, notStyledModal, wrapperStyle, value } = props
	const [sv, setSv] = useState(false)
	const { view, toggle, open, close } = useModalStore({
		def,
		afterClose: props.afterClose,
	})

	const ref = useRef<any>()
	const refBg = useRef<any>()

	useEffect(() => {
		if (value !== undefined) {
			if (value) {
				open()
				setSv(true)
			} else {
				close()
				setTimeout(() => {
					setSv(false)
				}, 10)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value])

	useEffect(() => {
		if (value === undefined) {
			if (view) {
				setSv(true)
			} else {
				setTimeout(() => {
					setSv(false)
				}, 10)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [view])

	const connect = {
		sv,
		refBg,
		view,
		close,
		ref,
		wrapperStyle,
		notStyledModal,
		id,
	}

	return { Modal, toggle, open, close, view, connect }
}

type ModalType = {
	connect: ModalConnectType
	mobile?: boolean
	children: React.ReactNode
	close?: (...props: any) => any
	custom?: boolean
	[key: string]: any
}

export type ModalConnectType = {
	sv: boolean
	refBg: React.MutableRefObject<any>
	view: boolean
	close: VoidFnType
	ref: React.MutableRefObject<any>
	wrapperStyle: any
	notStyledModal: boolean | undefined
	id?: string
}

const $modalZIndex = createStore<number[]>([1201])
const addZIndex = createEvent()
const removeZIndex = createEvent()

$modalZIndex
	.on(addZIndex, s => {
		const a = Array.from(s)
		a.push(a[a.length - 1] + 10)
		return a
	})
	.on(removeZIndex, s => {
		const a = Array.from(s)
		a.pop()
		return a
	})

/* export const useZIndexModal = (update?: any) => {
	const [zIndex, setZIndex] = useState(0)
	useEffect(() => {
		const zI = $modalZIndex.getState()
		if (update !== undefined && update) {
			setZIndex(zI[zI.length - 1])
			addZIndex()
		} else {
			setZIndex(zI[zI.length - 1])
			addZIndex()
		}
		return () => {
			if (update !== undefined && update) {
				setZIndex(0)
				removeZIndex()
			} else {
				setZIndex(0)
				removeZIndex()
			}
		}
	}, [update])

	return zIndex
} */

const Modal = ({
	children,
	connect,
	mobile = false,
	custom,
	...props
}: ModalType) => {
	const xs = useMatchMedia(x => x.less.xs)
	const zIndex = useZIndexModal(connect.id)

	return connect.sv
		? createPortal(
				<>
					{connect.view && (
						<ModalOverlay
							style={{ zIndex }}
							onClick={props.close ? props.close : connect.close}
						/>
					)}

					<DivHeight
						isHeight100={props.height}
						ref={connect.ref}
						mobileS={mobile}
						wrapperStyle={connect.wrapperStyle}
						zIndex={zIndex}
						xs={xs}
						style={{
							height: !connect.notStyledModal
								? isMobileOnly || mobile || xs
									? '100rvh'
									: props.height
									? props.height
									: 'auto'
								: 'auto',
						}}
					>
						{custom ? (
							children
						) : (
							// @ts-ignore
							<ModalContainer close={connect.close} {...props} mobile={mobile}>
								{children}
							</ModalContainer>
						)}
					</DivHeight>
				</>,
				// eslint-disable-next-line
				document.getElementById('modal-root')
		  )
		: null
}

const ModalOverlay = styled.div`
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.6);
	position: fixed;
	left: 0;
	top: 0;
	z-index: 1100;
`
const DivHeight = styled(Div100vh)`
	position: fixed;
	z-index: ${({ zIndex }) => zIndex};

	${({ isHeight100 }) =>
		isHeight100 &&
		css`
			& > div {
				height: 100%;
			}
		`}

	${({ wrapperStyle, mobileS, xs }) => {
		if (wrapperStyle) return wrapperStyle
		if (!isMobileOnly && !xs)
			return css`
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
				width: auto;
			`
		if (mobileS || xs)
			return css`
				width: 100%;
				top: 0;
				left: 0;
			`

		return css`
			width: 100%;
			top: 0;
			left: 0;
		`
	}}
`

Modal.Wrapper = DivHeight

export { Modal }
